import { createSlice } from '@reduxjs/toolkit'

const initialState = {
   geojsonData: null,
   
}

const overviewSlice = createSlice({
    name: 'overview',
    initialState,
    reducers: {
        setGeojsonData: (state, action) => {
            state.geojsonData = action.payload
        }
    }
})

export const { setGeojsonData } = overviewSlice.actions
export default overviewSlice.reducer